import { forwardRef, type ReactNode } from 'react';

interface ShareDeviceReservationDialogProps {
  children: ReactNode;
  className?: string;
}

export const ShareDeviceReservationDialog = forwardRef<
  HTMLDialogElement,
  ShareDeviceReservationDialogProps
>(({ children, className = '' }, ref) => {
  return (
    <dialog className={`dialog ${className}`.trim()} ref={ref}>
      {children}
    </dialog>
  );
});

ShareDeviceReservationDialog.displayName = 'ShareDeviceReservationDialog';
